module.exports = __webpack_public_path__ + "img/deskshelf17.d5544078.jpg";